import { Divider, Grid, Typography } from "@mui/material";
import { useState } from "react";
import CustomButton from "../../../components/CustomButton";
import Select from "../../../components/Select/Select";
import "../BranchManagement/BranchManagement.css";

const categoriesList = [
  "Procedure",
  "Diagnostics",
  "Administer",
  "Consumables",
  "Pet Shop Items",
  "Prescription",
  "Treatment Plan",
];

const stockNamingOptions = [
  { name: "Trade Name only", value: "trade" },
  { name: "Keywords only", value: "keywords" },
  { name: "Both — Trade Name primary", value: "trade-primary" },
  { name: "Both — Keywords primary", value: "keywords-primary" },
];

const serviceNamingOptions = [
  { name: "Service Name only", value: "service" },
  { name: "Variant Name only", value: "variant" },
  { name: "Both — Service Name primary", value: "service-primary" },
  { name: "Both — Variant Name primary", value: "variant-primary" },
];

const defaultCategorySettings = {
  Procedure: { stock: "trade-primary", service: "service" },
  Diagnostics: { stock: "trade-primary", service: "service" },
  Administer: { stock: "trade-primary", service: "service" },
  Consumables: { stock: "trade-primary", service: "service" },
  "Pet Shop Items": { stock: "trade-primary", service: "service" },
  Prescription: { stock: "trade-primary", service: "service" },
  "Treatment Plan": { stock: "trade-primary", service: "service" },
};

const getStockPreview = (mode) => {
  switch (mode) {
    case "trade":
      return "Amoxyclav 625";
    case "keywords":
      return "Amoxicillin + Clavulanic Acid";
    case "trade-primary":
      return "Amoxyclav 625 (Amoxicillin + Clavulanic Acid)";
    case "keywords-primary":
      return "Amoxicillin + Clavulanic Acid (Amoxyclav 625)";
    default:
      return "Amoxyclav 625";
  }
};

const getServicePreview = (mode) => {
  switch (mode) {
    case "service":
      return "General Consultation";
    case "variant":
      return "30-min · Senior Vet";
    case "service-primary":
      return "General Consultation (30-min · Senior Vet)";
    case "variant-primary":
      return "30-min · Senior Vet (General Consultation)";
    default:
      return "General Consultation";
  }
};

const WorkbookSettingsScreen = () => {
  const [selectedCategory, setSelectedCategory] = useState("Procedure");
  const [categorySettings, setCategorySettings] = useState(
    defaultCategorySettings,
  );

  const updateCategory = (cat, field, val) => {
    setCategorySettings((prev) => ({
      ...prev,
      [cat]: { ...(prev?.[cat] ?? {}), [field]: val },
    }));
  };

  const handleSave = () => {
    // Persist workbook naming preferences when API is wired.
  };

  const currentPreview = categorySettings?.[selectedCategory] ?? {
    stock: "trade-primary",
    service: "service",
  };

  return (
    <div className="consultation-white-con scroll-80vh p20">
      <div className="flex-row-between-align-center mb20 pb10">
        <div>
          <Typography className="text-bold fs20 black">
            Workbook Settings
          </Typography>
          <Typography className="txt-regular fs13 card-gray-color mt4">
            Choose how item names display within each clinical workflow — the
            same naming preference is reused on the invoice in Billing &amp;
            Finance.
          </Typography>
        </div>
        <div className="flex-row-ali-cen gap10">
          <CustomButton text="Save Changes" onClick={handleSave} smallBtn />
        </div>
      </div>
      <Divider />

      <Grid container spacing={3} className="mt20">
        <Grid item xs={12} md={8}>
          <div className="back-white br12 border overflow-hidden">
            <table
              className="w100Per border-collapse"
              style={{ tableLayout: "fixed" }}
            >
              <colgroup>
                <col style={{ width: "22%" }} />
                <col style={{ width: "39%" }} />
                <col style={{ width: "39%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th
                    className="text-left fs11 p12"
                    style={{
                      color: "#6B7280",
                      fontWeight: 600,
                      letterSpacing: "0.04em",
                      textTransform: "uppercase",
                      backgroundColor: "#F9FAFB",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Category
                  </th>
                  <th
                    className="text-left fs11 p12"
                    style={{
                      color: "#6B7280",
                      fontWeight: 600,
                      letterSpacing: "0.04em",
                      textTransform: "uppercase",
                      backgroundColor: "#F9FAFB",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Stock Item Display
                  </th>
                  <th
                    className="text-left fs11 p12"
                    style={{
                      color: "#6B7280",
                      fontWeight: 600,
                      letterSpacing: "0.04em",
                      textTransform: "uppercase",
                      backgroundColor: "#F9FAFB",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Service Item Display
                  </th>
                </tr>
              </thead>
              <tbody>
                {categoriesList.map((cat, index) => {
                  const isSelected = selectedCategory === cat;
                  const isLast = index === categoriesList.length - 1;
                  const settings = categorySettings?.[cat] ?? {
                    stock: "trade-primary",
                    service: "service",
                  };
                  return (
                    <tr
                      key={cat}
                      onClick={() => setSelectedCategory(cat)}
                      className="cursor"
                      style={{
                        backgroundColor: isSelected ? "#EFF6FF" : "#ffffff",
                        borderBottom: isLast ? "none" : "1px solid #E5E7EB",
                      }}
                    >
                      <td className="text-left font-bold fs13 black p12">
                        {cat}
                      </td>
                      <td
                        className="p10"
                        onClick={(e) => e.stopPropagation()}
                        style={{ width: "39%", minWidth: 220 }}
                      >
                        <div style={{ width: "100%", minWidth: 220 }}>
                          <Select
                            list={stockNamingOptions}
                            value={settings.stock}
                            handleChange={(e) =>
                              updateCategory(cat, "stock", e?.target?.value)
                            }
                            select
                            fullWidth
                          />
                        </div>
                      </td>
                      <td
                        className="p10"
                        onClick={(e) => e.stopPropagation()}
                        style={{ width: "39%", minWidth: 220 }}
                      >
                        <div style={{ width: "100%", minWidth: 220 }}>
                          <Select
                            list={serviceNamingOptions}
                            value={settings.service}
                            handleChange={(e) =>
                              updateCategory(cat, "service", e?.target?.value)
                            }
                            select
                            fullWidth
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography
            className="txt-semi-bold fs11 card-gray-color mb8"
            style={{ letterSpacing: "0.06em" }}
          >
            PREVIEW — {String(selectedCategory ?? "").toUpperCase()}
          </Typography>

          <div className="back-white br12 border p20">
            <Typography className="fs11 card-gray-color mb5">
              If this category lists a stock item:
            </Typography>
            <Typography className="font-bold fs14 black mb15">
              {getStockPreview(currentPreview.stock)}
            </Typography>

            <Typography className="fs11 card-gray-color mb5">
              If this category lists a service item:
            </Typography>
            <Typography className="font-bold fs14 black">
              {getServicePreview(currentPreview.service)}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default WorkbookSettingsScreen;
